// Aqui mostramos las cuentas de primer nivel
import React ,  { useState , useEffect } from 'react'
import DoCaseCard000 from './DoCaseCard000'

import axios from 'axios'

import { ApiCallGet } from '../ApiCall/ApiCall'


var arr = [

]


function DoCase000( { setSelected  , theCards , code="" , theCode , clean }) { // Se pasa el objeto seleccionado

const [cards,setCards] = useState( [])
const [array,setArray] = useState( [] ) 
const [lastCode,setlastCode] = useState( "" )

useEffect(() => {

    if ( clean )
    {
        setCards( [] );
    }
} ,[clean])


useEffect(() => {


    console.log( "LoadSecond code = " + code ) ;

    loadSecond() ;

},[code])


function loadSecond()
  {

    code = code.replace( "-" , "")

    console.log( "loadSecondLeft code = " + code )


    axios.get(  "http://localhost:3004/livefactura/getSecondLength/?code=" + code + "&len=1" )
    .then((response) => {
        console.log( "response(1) = " + JSON.stringify( response.data ) ) ;

        if ( response.data.length === 0 )
        {
            console.log( "No encontramos datos limpiamos el arreglo")
            setCards([])
            return ;
        }

        console.log( "casegroup  = " + JSON.stringify( response.data ) ) ;


        if ( response.data.length > 0 )
        {

            var arr2 = [] ;

            for( var i = 0 ; i < response.data.length ; i++)
            {
                console.log( "Codigo = " + response.data[i].second ) ;

                var obj = {} ;
                obj.id = response.data[i].idsecond  ; // idcasesatcodigo // idcasesatcodigo
                obj.field1 = response.data[i].parent ;
                obj.field3 = response.data[i].second ;  
                obj.field2 = "Marketing Director" ;
                obj.field4 = response.data[i].name ;
                obj.field5 = response.data[i].comment ;
                obj.field6 = "2024-02-11 17:01:02" ;   
                obj.naturaleza =  parseNaturaleza( response.data[i].second ); 
                
                
                arr2.push( obj ) ;

            }

            arr = arr2 ;

            setCards( arr2 ) ;

        }
        else{
            //setShowDrop ( false ) ;
        }



    })
    .catch( (err) => {
        console.log( err) ;
    })



  }

  function parseNaturaleza( nat )
  {

    /*
    100 Deudoras
    200 Acredoras
    300 Acredoras
    400 A/D  Todas son A , excepto 402 ( D )
    500 A/D ( 503 , 504 son A ) otras son deudoras
    600 Deudoras
    700 A/D  ( 701 D , 702 A , 703 D ,  704 A  )
    800 A/D  ( 801 , 802 , 803 , 804 ) Terminadoen en Non son D , y par es A
    */

    if ( nat.substring( 0 , 2 ) === '10' || nat.substring(0,2) === '60' )
    {
        return "D" ;
    }

    if ( nat.substring( 0 , 2 ) === '20' || nat.substring(0,2) === '30' )
    {
        return "A" ;
    }

    if ( nat.substring( 0 , 2 ) === '40')
    {
        if ( nat === '402')
        {
            return 'D' ;
        }

        return 'A' ;
    }

    if ( nat.substring( 0 , 2 ) === '50' )
    {
        if ( nat === '503' || nat === '504' )
        {
            return 'A' ;
        }

        return 'D' ;

    }

    if ( nat.substring( 0 ,2 ) === '70' )
    {
        if ( nat === '701' || nat === '703')
        {
            return 'D' ;
        }

        return 'A'
    }


    if ( nat.substring( 0 , 2) === '80' )
    {
        if ( nat === '801' || nat === '803')
        {
            return 'D' ;
        }

        return 'A' ;
    }

  }


  useEffect(()  => {

    console.log( "lastCode *** = " + lastCode )

} , [lastCode])


    function theSelected( index )
    {
        console.log( "Se selecciono el index(1) = " + index + " data = " + cards[index].field3) ;

        setSelected( arr[index] )


        


        // select idcatcasegroup ,name,cuenta,comentario from cat_casegroup where cuenta like('$$01%')

        // getSecondLength // getGrupo
        axios.get(  "http://localhost:3004/livefactura/getSecondLength/?code=" + cards[index].field3 + "&len=2")
        .then((response) => {
            console.log( "response(1) = " + JSON.stringify( response.data ) ) ;


            if ( response.data.length === 0  )
            {
                
                    console.log( "**************** generando error") ;

                    theCode( "err")
                    return ;

                
            }

            console.log( "casegroup  = " + JSON.stringify( response.data[0].second ) ) ;


            if ( response.data.length > 0 )
            {
                //setShowDrop( true ) ;
    
                var arr = [] ;
    
                for( var i = 0 ; i < response.data.length ; i++)
                {
                    console.log( "Codigo = " + response.data[i].second ) ;

                    var obj = {} ;
                    obj.id = response.data[i].idsecond  ; // idcasesatcodigo // idcasesatcodigo
                    obj.field1 = response.data[i].parent ;
                    obj.field3 = response.data[i].second ;  
                    obj.field2 = "Marketing Director" ;
                    obj.field4 = "Hola , es una prueba";
                    obj.field5 = "Creado por Charly" ;
                    obj.field6 = "2024-02-11 17:01:02" ;   
                    //obj.idcatcasegroup = response.data[i].idcasesatcodigo ;  
                    
                    
                    arr.push( obj ) ;
    
                }
    

                theCards( arr ) ;

                if ( arr.length === 0 )
                {
                    console.log( "**************** generando error") ;

                    theCode( "err")
                    return ;
                }


                var myCode = cards[index].field3 ;
    

                console.log( "code = " + cards[index].field3 )
        
                if ( cards[index].field3 === ( lastCode.replace( "-" , " ") ) )
                {
                    if ( lastCode.indexOf('-') >=0 )
                    {
                        myCode = cards[index].field3 ;
        
                    }
                    else{
        
                        myCode = '-' + myCode ;
        
        
                    }
                }
        
        
                console.log( "Cambiando codigo(2) " + myCode )
                setlastCode( myCode ) ;
        




                theCode( myCode ) ; //cards[index].field3
    
            }
            else{
                //setShowDrop ( false ) ;
            }
    


        })
        .catch( (err) => {
            console.log( err) ;
        })
    }

  return (
    
        <>
            <div style={{overflowY:'auto' , overflowX :'hidden', height : '90%'}}>

                {

                    cards.map( (data,index) =>
                        <>
                        {

                        

                            <DoCaseCard000 data={data} naturaleza={data.naturaleza} 
                            index={index} selected={theSelected}></DoCaseCard000>

                        }
                        </>
                        
                        
                    )


                }
                
                {/* <DoCasePlus type={'group'}></DoCasePlus> */}

            </div>

            

        </>

  )
}

export default DoCase000